import { getRequestPAdmin } from "common/HttpClient/http-utility";
import INFRAMARK_CONSTANTS from "common/Constants/inframark-constants";
import { PLATFORM_ROLE } from "common/Constants/PlatformRole.constants";

const extractCustomerRolesPayload = (responseData) => {
  if (Array.isArray(responseData)) {
    return responseData;
  }
  if (responseData && Array.isArray(responseData.response)) {
    return responseData.response;
  }
  if (responseData && Array.isArray(responseData.data)) {
    return responseData.data;
  }
  return [];
};

const mapApiRoleToSelectOption = (role) => ({
  label: role.displayName || role.name || "",
  value: role.name,
});

const sortRolesBySortOrder = (list) =>
  [...list].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));

const fetchCustomerRolesRawList = async () => {
  const path = INFRAMARK_CONSTANTS.groups.services.customerRoles;
  try {
    const response = await getRequestPAdmin(path);
    if (!response?.error) {
      return sortRolesBySortOrder(extractCustomerRolesPayload(response?.data));
    }
  } catch {
  }
  return [];
};

const mapGrantableRolesToSelectOptions = (rawList) =>
  (rawList ?? [])
    .filter(
      (role) =>
        role.grantable !== false &&
        role.name.toLowerCase() !== PLATFORM_ROLE.PLATFORM_ADMIN.toLowerCase()
    )
    .map(mapApiRoleToSelectOption)
    .filter((option) => option.value);

export const buildCustomerRoleLabelMap = (rawList = []) =>
  Object.fromEntries(
    (rawList ?? [])
      .map((role) => {
        const name = String(role?.name ?? "").trim();
        if (!name) {
          return null;
        }
        const label = String(role?.displayName ?? role?.name ?? "").trim() || name;
        return [name, label];
      })
      .filter(Boolean)
  );

export async function fetchCustomerRolesData() {
  const rawList = await fetchCustomerRolesRawList();
  const options = mapGrantableRolesToSelectOptions(rawList);
  return {
    options: options.length ? options : [],
    labelMap: buildCustomerRoleLabelMap(rawList),
  };
}

export async function fetchCustomerRolesCatalog() {
  return fetchCustomerRolesRawList();
}

export async function fetchAppCustomerRolesMaster() {
  const { options } = await fetchCustomerRolesData();
  return options;
}

export async function syncCustomerRoleOptions(
  profile,
  setCustomerRoleOptions,
  setCustomerRoleLabelMap
) {
  const { options, labelMap } = await fetchCustomerRolesData();
  if (profile) {
    profile.customerRoleOptions = options;
    profile.customerRoleLabelMap = labelMap;
  }
  setCustomerRoleOptions?.(options);
  setCustomerRoleLabelMap?.(labelMap);
  return { options, labelMap };
}
